import { baseApi } from './baseSplit';
import {
    GET_TOKEN,
    UPDATE_CANCEL_LOGISTIC_JOB_STATUS,
    WEB_API_KEY,
    CANCEL_BOOKING,
    ADD_IMAGE,
    STORE_CUSTOMER_QUESTION_ANSWER_RESPONSE,
    GET_TEXT_FREE_ADDRESSES,
    GET_LOCATION,
    _header
} from '../../globals';

const header = {
    'Ocp-Apim-Subscription-Key': WEB_API_KEY,
};

const accountEndPoints = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getAdminAuthToken: build.mutation({
            query: (request) => ({
                url: GET_TOKEN,
                method: 'POST',
                headers: {
                    ...header,
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: 'grant_type=password&username=' + encodeURIComponent(request.email) + '&password=' + encodeURIComponent(request.password),
            }),
        }),
        updateOnfleetJobStatus: build.mutation({
            query: (data) => ({
                url: UPDATE_CANCEL_LOGISTIC_JOB_STATUS,
                method: 'POST',
                headers: {
                    ...header,
                    Authorization: data.token,
                },
                body: data.request,
            }),
        }),
        cancelBooking: build.mutation({
            query: (data) => ({
                url: CANCEL_BOOKING,
                method: 'POST',
                headers: _header,
                body: data.request,
            }),
        }),
        addImage: build.mutation({
            query: (data) => ({
                url: ADD_IMAGE,
                method: 'POST',
                headers: _header,
                body: data.formData,
            }),
        }),
        fetchAddresses: build.mutation({
            query: ({ value, countryCode, container, signal }) => ({
                url: GET_TEXT_FREE_ADDRESSES,
                method: 'POST',
                headers: {
                    ...header,
                },
                params: {
                    Key: 'KU54-HR99-HU89-EG38',
                    Text: value,
                    Countries: countryCode,
                    Language: 'en',
                    Container: container ?? '',
                },
                signal,
            }),
            transformResponse: (response: any) => ({
                Items: response.Items.filter(
                    (i) =>
                        i.Type === 'Address' ||
                        i.Type === 'Street' ||
                        i.Type === 'Postcode' ||
                        i.Type === 'BuildingNumber' ||
                        i.Type === 'BuildingName'
                ),
            }),
        }),
        getLocation: build.mutation({
            query: ({ searchId, partialSearch, airportCode }) => ({
                url: GET_LOCATION,
                method: 'POST',
                headers: {
                    ...header,
                },
                body: {
                    locationProvider: 3,
                    locationType: 4,
                    searchId,
                    partialSearch,
                    airportCode,
                },
            }),
        }),
        storeCustomerQuestionAnswerResponse: build.mutation({
            query: (data) => ({
                url: STORE_CUSTOMER_QUESTION_ANSWER_RESPONSE,
                method: 'POST',
                headers: _header,
                body: data.request,
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetAdminAuthTokenMutation,
    useUpdateOnfleetJobStatusMutation,
    useCancelBookingMutation,
    useAddImageMutation,
    useStoreCustomerQuestionAnswerResponseMutation,
    useFetchAddressesMutation,
    useGetLocationMutation,
} = accountEndPoints;
